import { render, staticRenderFns } from "./deleteTask.vue?vue&type=template&id=8b42273c"
import script from "./deleteTask.vue?vue&type=script&lang=js"
export * from "./deleteTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports